export default {
  title: 'QR Code Menus',
  newMenu: 'New menu',
  name: 'Name',
  createdAt: 'Created at',
  enabled: 'Enabled',
  actions: 'Actions',
  editLinks: 'Edit links',
  editSettings: 'Edit settings'
}
